type ExpirableData<T> = {
	value: T;
	expiresAt: number;
};

export const setSession = <T>(
	key: 'userInfo',
	value: T,
	ttlMinutes: number
) => {
	const expiresAt = Date.now() + ttlMinutes * 60 * 1000;
	const data: ExpirableData<T> = { value, expiresAt };
	sessionStorage.setItem(key, JSON.stringify(data));
};

export const getSession = <T>(key: 'userInfo'): T | null => {
	const raw = sessionStorage.getItem(key);
	if (!raw) return null;

	try {
		const parsed: ExpirableData<T> = JSON.parse(raw);
		if (Date.now() > parsed.expiresAt) {
			sessionStorage.removeItem(key);
			return null;
		}
		return parsed.value;
	} catch {
		return null;
	}
};

export const deleteSession = (key: 'userInfo') => {
	sessionStorage.removeItem(key);
};
